// Phone numbers are typed in several places (profile sheet, membership application,
// event RSVP, admin user create) and read back by two things that need them to be
// consistent: formatPhone for display, and the Square customer matcher, which
// compares digits only (server/src/services/membershipService.js). Anything typed
// used to be stored verbatim, so "asdasdasd" and "(512) 555-0148" and "5125550148"
// all coexisted. Validate on the way in, store one shape, format on the way out.
//
// Kept in step with server/src/utils/phone.js - the API is the real boundary, so the
// same rules run there. Change both together.

// The stored shape: bare 10 digits for a US number, "+" and country code for anything
// else. Display formatting is formatPhone's job, not storage's.
export function normalizePhone(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return '';

  const digits = raw.replace(/\D/g, '');
  if (raw.startsWith('+')) return `+${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1);
  return digits;
}

// Returns '' when the value is acceptable, otherwise the message to show. Empty is
// acceptable everywhere: the field is optional on every form that collects it.
export function phoneError(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return '';

  if (raw.indexOf('+') > 0) {
    return 'A + only belongs at the start, in front of the country code.';
  }
  if (/[^0-9+()\-.\s]/.test(raw)) {
    return 'Use digits only. Spaces, dashes, dots and brackets are fine.';
  }

  const normalized = normalizePhone(raw);

  if (normalized.startsWith('+')) {
    const digits = normalized.slice(1);
    if (digits.length < 8 || digits.length > 15) {
      return 'Enter an international number as + then 8 to 15 digits.';
    }
    return '';
  }

  if (normalized.length !== 10) {
    return 'Enter a 10-digit US number, or + and the country code for an international one.';
  }
  return '';
}
